// extracted by mini-css-extract-plugin
export var round = "ButtonPlay-module--round--xVpty";
export var text = "ButtonPlay-module--text--u9FPR";
export var wrapper = "ButtonPlay-module--wrapper--YqMbj";